module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step2a_Image9.ce91c2f5.jpg";